module.exports = __webpack_public_path__ + "img/Hands-icon-raised.11bbe71e.png";